document.addEventListener('change', function(e){
  if(e.target && e.target.matches('[data-variant-select]')){
    const option = e.target.options[e.target.selectedIndex];
    const form = e.target.closest('form');
    const root = e.target.closest('[data-product-root]');
    const price = form?.querySelector('[data-product-price]');
    const button = form?.querySelector('[data-add-button]');
    const image = root?.querySelector('[data-product-main-image]');
    const placeholder = root?.querySelector('[data-product-placeholder]');
    const isVariantArt = root?.dataset.variantArt === 'true';

    if(price && option.dataset.price) price.textContent = option.dataset.price;

    if(button){
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Add to cart' : 'Sold out';
    }

    if(image && option.dataset.image){
      image.src = option.dataset.image;
      image.alt = option.dataset.alt || '';
      image.style.display = '';
      if(placeholder) placeholder.style.display = 'none';
    } else if(isVariantArt) {
      if(image) image.style.display = 'none';
      if(placeholder) placeholder.style.display = '';
    }
  }
});

function applySinglesFilters(){
  const root = document.querySelector('[data-singles-filter-root]');
  if(!root) return;
  const search = (root.querySelector('[data-singles-search]')?.value || '').trim().toLowerCase();
  const ink = (root.querySelector('[data-filter-ink]')?.value || '').toLowerCase();
  const rarity = (root.querySelector('[data-filter-rarity]')?.value || '').toLowerCase();
  const finish = (root.querySelector('[data-filter-finish]')?.value || '').toLowerCase();
  const set = root.querySelector('[data-filter-set]')?.value || '';
  const popularView = root.querySelector('[data-popular-view]');
  const catalogueView = root.querySelector('[data-catalogue-view]');
  const popularOnly = Boolean(popularView && root.dataset.browseMode !== 'all' && !search && !ink && !rarity && !finish && !set);
  if(popularView) popularView.hidden = !popularOnly;
  if(catalogueView) catalogueView.hidden = popularOnly;
  const cards = [...root.querySelectorAll('[data-catalogue-grid] [data-product-card]')];
  let shown = 0;

  cards.forEach(card => {
    const title = card.dataset.title || '';
    const tags = card.dataset.tags || '';
    const variants = card.dataset.variants || '';
    const haystack = title + ' ' + tags + ' ' + variants;
    const okSearch = !search || haystack.includes(search);
    const exactTags = tags.split('|').map(tag => tag.trim());
    const normalizedTags = exactTags.map(tag => tag.replace(/^ink\s*:\s*/, '').trim());
    const variantParts = variants.split('|').flatMap(value => value.split('/')).map(value => value.trim());
    const okInk = !ink || normalizedTags.some(tag => tag === ink || tag.split(/\s*[-/]\s*/).includes(ink));
    const okRarity = !rarity || normalizedTags.includes(rarity);
    const okFinish = !finish || variantParts.includes(finish) || normalizedTags.includes(finish);
    const normalizedSet = set.replace(/-/g, ' ');
    const okSet = !set || normalizedTags.includes(normalizedSet);
    const show = okSearch && okInk && okRarity && okFinish && okSet;
    card.style.display = show ? '' : 'none';
    if(show) shown++;
  });

  const count = root.querySelector('[data-filter-count]');
  if(count){
    const popularCount = root.querySelectorAll('[data-popular-grid] [data-product-card]').length;
    count.textContent = popularOnly ? root.dataset.popularCountLabel.replace('__COUNT__', popularCount) : shown + (shown === 1 ? ' card shown' : ' cards shown');
  }

  const empty = root.querySelector('[data-no-filter-results]');
  if(empty) empty.style.display = !popularOnly && shown === 0 ? 'block' : 'none';
}

document.addEventListener('input', function(e){
  if(e.target && e.target.matches('[data-singles-search]')) applySinglesFilters();
});

document.addEventListener('change', function(e){
  if(e.target && e.target.matches('[data-filter-set],[data-filter-ink],[data-filter-rarity],[data-filter-finish]')) applySinglesFilters();
});

document.addEventListener('click', function(e){
  const reset = e.target.closest('[data-reset-filters]');
  if(reset){
    const root = reset.closest('[data-singles-filter-root]');
    if(root){
      root.dataset.browseMode = 'popular';
      const setSelect = root.querySelector('[data-filter-set]');
      const resetSet = setSelect && setSelect.value;
      root.querySelectorAll('select').forEach(s => s.selectedIndex = 0);
      const search = root.querySelector('[data-singles-search]');
      if(search) search.value = '';
      const url = new URL(window.location.href);
      url.searchParams.delete('q');
      url.searchParams.delete('page');
      url.searchParams.delete('browse');
      if(resetSet){
        url.pathname = setSelect.dataset.collectionUrl;
        window.location.assign(url.href);
        return;
      }
      window.history.replaceState({}, '', url);
      applySinglesFilters();
    }
  }

  const minus = e.target.closest('[data-cart-qty-minus]');
  const plus = e.target.closest('[data-cart-qty-plus]');
  if(minus || plus){
    const quantity = e.target.closest('.cart-quantity');
    const input = quantity?.querySelector('[data-cart-qty-input]');
    if(input){
      const current = parseInt(input.value || '0', 10);
      input.value = minus ? Math.max(0, current - 1) : current + 1;
    }
  }
});

document.addEventListener('DOMContentLoaded', function(){
  const root = document.querySelector('[data-singles-filter-root]');
  if(root){
    const params = new URLSearchParams(window.location.search);
    if(Number(params.get('page') || 1) > 1) root.dataset.browseMode = 'all';
    const setSelect = root.querySelector('[data-filter-set]');
    if(setSelect){
      const selectedSet = setSelect.value;
      [...setSelect.options].filter(option => option.value)
        .sort((a, b) => Number(b.value.match(/\d+/)?.[0] || 0) - Number(a.value.match(/\d+/)?.[0] || 0))
        .forEach(option => setSelect.appendChild(option));
      setSelect.value = selectedSet;
    }
    const q = params.get('q');
    if(q){
      const search = root.querySelector('[data-singles-search]');
      if(search) search.value = q;
    }
  }
  const grid = root?.querySelector('[data-catalogue-grid]');
  if(grid){
    const cardNumber = card => Number((card.dataset.title || '').match(/#(\d+)\/\d+/)?.[1] || Number.MAX_SAFE_INTEGER);
    const setNumber = card => Number((card.dataset.tags || '').split('|').map(tag => tag.trim()).find(tag => /^set\s+\d+$/.test(tag))?.match(/\d+/)?.[0] || 0);
    [...grid.querySelectorAll('[data-product-card]')]
      .sort((a, b) => setNumber(b) - setNumber(a) || cardNumber(a) - cardNumber(b))
      .forEach(card => grid.appendChild(card));
  }
  applySinglesFilters();
});


